import React from "react";
import { Box, createStyles, withStyles } from "@material-ui/core";
import OptionRow from "./OptionRow.web";

export interface SurveyOption {
  id: number | string;
  attributes?: {
    description?: string;
    displaydescription?: string;
  };
}

interface Props {
  options?: SurveyOption[];
  selected?: SurveyOption | SurveyOption[] | null;
  multiple?: boolean;
  onSelect: (option: SurveyOption) => void;
  optionClassName?: string;
  classes: Record<string, string>;
}

const styles = createStyles({
  list: {
    display: "flex",
    flexDirection: "column",
    gap: 12,
  },
});

const isSelected = (
  option: SurveyOption,
  selected: Props["selected"]
): boolean => {
  if (Array.isArray(selected)) {
    return selected.some((item) => item?.id === option.id);
  }
  return selected?.id === option.id;
};

export const getOptionLabel = (option: SurveyOption): string =>
  option.attributes?.displaydescription || option.attributes?.description || "";

const OptionList = ({
  options = [],
  selected,
  multiple,
  onSelect,
  optionClassName,
  classes,
}: Props) => (
  <Box className={classes.list} role={multiple ? "group" : "radiogroup"}>
    {options.map((option) => (
      <OptionRow
        key={option.id}
        label={getOptionLabel(option)}
        selected={isSelected(option, selected)}
        multiple={multiple}
        onSelect={() => onSelect(option)}
        className={optionClassName}
      />
    ))}
  </Box>
);

export default withStyles(styles)(OptionList);
